import { useEffect, useState } from "react";
import { listarKPIs } from "../../services/kpisService";
import {
  collection,
  getDocs
} from "firebase/firestore";
import { db } from "../Config/firebase";
import { consultaTenantAtual } from "../Utils/tenant";
import Navbar from "../Components/Navbar/navbar";

import KPIFormModal from "./components/KPIFormModal";
import KPIQuestionsModal from "./components/KPIQuestionsModal";

/* =========================
   HELPERS
========================= */
function formatarCodigoRQ(codigo = "") {
  return codigo.replace(/^RQ_/i, "RQ ").replaceAll("_", ".");
}

export default function AdminKPIs() {
  const [kpis, setKpis] = useState([]);
  const [escopos, setEscopos] = useState([]);
  const [loading, setLoading] = useState(true);

  const [modalKPIOpen, setModalKPIOpen] = useState(false);
  const [modalPerguntasOpen, setModalPerguntasOpen] = useState(false);
  const [kpiSelecionado, setKpiSelecionado] = useState(null);

  /* =========================
     LOAD
  ========================= */
  async function carregarKPIs() {
    const lista = await listarKPIs();
    setKpis(lista || []);
  }

  async function carregarEscopos() {
    const snap = await getDocs(consultaTenantAtual(collection(db, "kpi_escopos")));
    setEscopos(
      snap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }))
    );
  }

  useEffect(() => {
    async function init() {
      setLoading(true);
      await Promise.all([carregarKPIs(), carregarEscopos()]);
      setLoading(false);
    }
    init();
  }, []);

  /* =========================
     HELPERS
  ========================= */
  function nomeEscopo(codigo) {
    if (!codigo) return "—";
    return escopos.find(e => e.codigo === codigo)?.nome || codigo;
  }
  /* =========================
     RENDER
  ========================= */
  return (
    <>
      <Navbar />

      <div className="container mt-4">
        <div className="d-flex justify-content-between mb-3">
          <h3>KPIs</h3>
          <button
            className="btn btn-primary"
            onClick={() => {
              setKpiSelecionado(null);
              setModalKPIOpen(true);
            }}
          >
            Novo KPI
          </button>
        </div>

        {loading ? (
          <p>Carregando...</p>
        ) : (
          <table className="table table-hover align-middle">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Código</th>
                <th>Escopo</th>
                <th>Status</th>
                <th width="220">Ações</th>
              </tr>
            </thead>

            <tbody>
              {kpis.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-muted">
                    Nenhum KPI cadastrado
                  </td>
                </tr>
              ) : (
                kpis.map(k => (
                  <tr key={k.id}>
                    <td>{k.nome}</td>
                    <td>{formatarCodigoRQ(k.codigo)}</td>
                    <td>{nomeEscopo(k.escopo)}</td>
                    <td>
                      <span
                        className={`badge ${
                          k.ativo ? "bg-success" : "bg-secondary"
                        }`}
                      >
                        {k.ativo ? "Ativo" : "Inativo"}
                      </span>
                    </td>

                    <td className="d-flex gap-2">
                      {/* EDITAR */}
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => {
                          setKpiSelecionado(k.id);
                          setModalKPIOpen(true);
                        }}
                      >
                        Editar
                      </button>

                      {/* PERGUNTAS – SOMENTE KPI DE PESQUISA */}
                      {k.tipoKPI === "PESQUISA" && (
                        <button
                          className="btn btn-sm btn-outline-success"
                          onClick={() => {
                            setKpiSelecionado(k.id);
                            setModalPerguntasOpen(true);
                          }}
                        >
                          Perguntas +
                        </button>
                      )}

                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* ===== MODAL KPI (CRIAR / EDITAR) ===== */}
      <KPIFormModal
        open={modalKPIOpen}
        kpiId={kpiSelecionado}
        onClose={() => setModalKPIOpen(false)}
        onSaved={() => {
          carregarKPIs();
          carregarEscopos();
        }}
      />

      {/* ===== MODAL PERGUNTAS ===== */}
      <KPIQuestionsModal
        open={modalPerguntasOpen}
        kpiId={kpiSelecionado}
        onClose={() => setModalPerguntasOpen(false)}
      />
    </>
  );
}
